import { PropsWithChildren, useContext, useMemo, useState } from "react";
import { Button, Field, Input, Spinner, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    InfoRegular
} from "@fluentui/react-icons";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IApiError } from "@interfaces/common.interfaces";
import { getError } from "lib/utils";
import ApiErrorBar from "components/common/api-error-bar/api-error-bar";
import { FieldValues, useFormContext } from "react-hook-form";
import { ITextFieldProps } from "./text-field.props";

const layoutStyles = makeStyles({
    mainWrapper: {

    }
});

export default function TextField<T extends FieldValues>(props: ITextFieldProps<T>) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();
    const { register, formState: { errors, isSubmitted, isSubmitting, isLoading } } = useFormContext<T>();

    const validationMessage = useMemo(() => {
        if (props.fieldName && errors[props.fieldName]) {
            return errors[props.fieldName]?.message?.toString();
        }
        return "";
    }, [props.fieldName, errors[props.fieldName]]);

    return (
        <div className={styles.mainWrapper}>
            <Field
                label={t(props.label)}
                validationMessage={validationMessage}
                required={props.required}>
                <Input defaultValue="" {...register(props.fieldName)} disabled={isSubmitting || isLoading} />
            </Field>
        </div>
    );
}